module.exports = __webpack_public_path__ + "static/media/gps.b8e183c1.svg";